module.exports = __webpack_public_path__ + "assets/img/2.d957e19e.jpg";